let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("caOJN")).then(() => parcelRequire('fwtiz'));